import { jwtDecode } from 'jwt-decode'
import { getDefaultAuthProvider } from './AuthProvider'

/**
 * Claim the API stamps on the token while an administrator-issued password is still in place.
 * It is emitted only when true, so an absent claim means the password has been set by the user.
 */
export const MUST_CHANGE_PASSWORD_CLAIM = 'must_change_password'

const isTrue = (value: unknown) => value === 'true' || value === true

/**
 * Reads the flag off whichever token the active provider holds. This mirrors the server-side
 * check in MustChangePasswordMiddleware; it exists to route the user to the right screen, not
 * to enforce anything — the API refuses the calls regardless.
 */
export const readMustChangePassword = (token?: string | null): boolean => {
  try {
    const activeToken = token ?? getDefaultAuthProvider().getToken()
    if (!activeToken) return false

    const decoded = jwtDecode<Record<string, unknown>>(activeToken)
    return isTrue(decoded?.[MUST_CHANGE_PASSWORD_CLAIM])
  } catch {
    return false
  }
}
